import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { GridsterModule } from 'angular-gridster2';
import { DxButtonModule } from 'devextreme-angular';
import { DashboardDataService } from './data/dashboard-data.service';
import { WidgetWrapperComponent } from './widgets/widget/widget.component';
import { ILayout } from './widgets/widget/base/base-widget';
import { DashboardService } from 'src/api/generated';
import { RemoteDataWrapperService } from '../../shared/services/remote-data/remote-data-wrapper.service';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { PipesModule } from 'acl-cloud-lib';
@Component({
  selector: 'app-dashboard-page',
  standalone: true,
  imports: [CommonModule, WidgetWrapperComponent, DxButtonModule, GridsterModule, PipesModule],
  templateUrl: './dashboard-page.component.html',
  styleUrl: './dashboard-page.component.scss'
})
export class DashboardPageComponent implements OnInit {
   
  public defaultLayouts: ILayout[] = [];

  constructor(
    public readonly dashboardDataSvc: DashboardDataService,
    private readonly _dashboardSvc: DashboardService,
    private readonly _remoteDataWrapperService: RemoteDataWrapperService,
    private readonly _router: Router
  ){
  }

  ngOnInit(): void {
    this._dashboardSvc.getLayoutsDashboard().subscribe(layouts => {
      if (layouts && layouts.length > 0) {
        this.defaultLayouts = layouts.map((layout: any) => {
          return {
            name: layout.Name,
            icon: layout.Icon,
            layout: JSON.parse(layout.Layout)
          }
        });
      }
    });

    this._remoteDataWrapperService.turnOnCommunication();

    const sub = this._router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {

        if (window.location.hash === '#/dashboard') {
          this._remoteDataWrapperService.turnOffCommunication();
        }

      } else if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
        this._remoteDataWrapperService.clearUnusedConnections();
        sub.unsubscribe();
      }
    });
  }

  setLayout(layout: any): void {
    this.dashboardDataSvc.setLayout(layout);
  }

  addEmptyWidget(): void {
    this.dashboardDataSvc.addWidget();
  }

  onEdit(): void {
    const sub = this.dashboardDataSvc.onLastWidgetDestroyed.subscribe(() => {
      this._remoteDataWrapperService.turnOnCommunication();
      
      sub.unsubscribe();
    });

    this._remoteDataWrapperService.turnOffCommunication();
    
    this.dashboardDataSvc.toggleEditMode();
  }

  onEditClose(): void {
    const sub = this.dashboardDataSvc.onLastWidgetInitialized.subscribe(() => {
      this._remoteDataWrapperService.turnOnCommunication();
      sub.unsubscribe();
    });

    this._remoteDataWrapperService.turnOffCommunication();

    this.dashboardDataSvc.toggleEditMode();
  }
}
